// extracted by mini-css-extract-plugin
module.exports = {"card":"user-card_card__Eo8Aq","title":"user-card_title__kWytG","detail":"user-card_detail__1-49y"};